import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';

import defer from 'lodash-es/defer';

@Component({
  selector: 'app-chip',
  templateUrl: './chip.component.html',
})
export class ChipComponent implements AfterViewInit {
  @Input() iconPrefix: string;
  @Input() isClickable = false;
  @ViewChild('textContent') textContent: ElementRef;
  toolTipContent: string;

  ngAfterViewInit() {
    defer(() => this.projectContentChanged());
  }

  projectContentChanged() {
    const { innerText, offsetWidth, scrollWidth } =
      this.textContent.nativeElement || {};
    if (offsetWidth < scrollWidth) {
      this.toolTipContent = innerText;
    }
  }
}
